import { render, staticRenderFns } from "./CourseCorrelationInfo.vue?vue&type=template&id=98ecd9a8&scoped=true&"
import script from "./CourseCorrelationInfo.vue?vue&type=script&lang=js&"
export * from "./CourseCorrelationInfo.vue?vue&type=script&lang=js&"
import style0 from "./CourseCorrelationInfo.vue?vue&type=style&index=0&id=98ecd9a8&prod&lang=css&"
import style1 from "./CourseCorrelationInfo.vue?vue&type=style&index=1&id=98ecd9a8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98ecd9a8",
  null
  
)

export default component.exports